import Request from '../request'
import URL from '../url'

// Google Drive
export const headlessGoogleDriveAuthUrl = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_AUTH_URL).get()

export const headlessGoogleDriveStatus = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_STATUS).get()

export const headlessGoogleDriveFolders = parentId =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_FOLDERS).get({
    parent_id: parentId || 'root',
  })

export const headlessGoogleDriveFiles = folderId =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_FILES).get({
    folder_id: folderId,
  })

export const headlessGoogleDrivePlan = folderId =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_PLAN).get({
    folder_id: folderId,
  })

export const headlessGoogleDriveDisconnect = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GOOGLE_DRIVE_DISCONNECT).delete()

// BYOK
export const headlessStoreApiKeys = (keys = {}) =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_STORE_API_KEY).post(keys)

export const headlessApiKeyStatus = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_API_KEY_STATUS).get()

export const headlessDeleteApiKey = (keyType = 'google_api_key') =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_DELETE_API_KEY).delete({
    key_type: keyType,
  })

export const headlessHeygenCredits = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_HEYGEN_CREDITS).get()

// Course-generation prompt overrides (per-user)
export const headlessGetPrompts = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_PROMPTS).get()

export const headlessStorePrompts = (prompts = {}) =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_PROMPTS).put(prompts)

export const headlessResetPrompt = (field) =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_PROMPTS).delete({ field })

// Process Documents + Analyze + Generate
export const headlessProcessDocuments = data =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_PROCESS_DOCUMENTS).post(data)

export const headlessAnalyze = data =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_ANALYZE).post(data)

export const headlessGenerate = data =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_GENERATE).post(data)

// Collection Builder Settings
export const headlessCbSettingsGet = () =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_CB_SETTINGS).get()

export const headlessCbSettingsPatch = data =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_CB_SETTINGS).patch(data)

// Sessions
export const headlessListSessions = (skip = 0, limit = 20) =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_SESSIONS).get({ skip, limit })

export const headlessCreateSession = data =>
  new Request(URL.APP_URL_LLM, URL.HEADLESS_SESSIONS).post(data)

export const headlessGetSession = id =>
  new Request(URL.APP_URL_LLM, `${URL.HEADLESS_SESSIONS}/${id}`).get()

export const headlessUpdateSession = (id, data) =>
  new Request(URL.APP_URL_LLM, `${URL.HEADLESS_SESSIONS}/${id}`).put(data)

export const headlessDeleteSession = id =>
  new Request(URL.APP_URL_LLM, `${URL.HEADLESS_SESSIONS}/${id}`).delete()
